import React from "react";
import * as styles from "./ExcursionActivityLevel.module.scss";
import { t, Trans } from "@lingui/macro";
import classNames from "classnames";
import { i18n } from "@lingui/core";
import { Icon } from "@silversea-ssc/ui-components-react";

export interface ExcursionActivityLevelProps {
  level: number;
  titleClassName?: string;
}

const unknownLevel = {
  fullIcons: 0,
  label: ""
};

const levelsDefinitions = {
  1: {
    fullIcons: 1,
    label: t`Minimal`,
    description: t`activity-level1-description`
  },
  2: {
    fullIcons: 2,
    label: t`Moderate`,
    description: t`activity-level2-description`
  },
  3: {
    fullIcons: 3,
    label: t`Extensive`,
    description: t`activity-level3-description`
  },
  4: {
    fullIcons: 4,
    label: t`Physically fit`,
    description: t`activity-level4-description`
  }
};

const ExcursionActivityLevel: React.FC<ExcursionActivityLevelProps> = ({
  level,
  titleClassName = undefined
}) => {
  const { fullIcons, label } = levelsDefinitions[level] || unknownLevel;
  const icons = Array(4)
    .fill("activity-level-empty")
    .fill("activity-level-full", 0, fullIcons);
  return (
    <div className={styles.container}>
      <div
        className={classNames({
          [styles.title]: true,
          [titleClassName || ""]: titleClassName
        })}
      >
        <Trans>Activity Level</Trans>
      </div>
      <div className={styles.icons}>
        {icons.map((i, index) => (
          <Icon
            key={`${i}-${index}`}
            name={i}
            size="0.5x"
            padding="inline"
            className={styles.icon}
          />
        ))}
      </div>
      <div>{i18n._(label)}</div>
    </div>
  );
};

export default ExcursionActivityLevel;
